<div class="row m-0 pt-5">
	<div class="col-lg-12">
		<div class="titolo text-center pt-5">
			<img
				src="./assets/imgs/logo_open_fiber_magenta.png?v={{ assets_version }}"
				srcset="./assets/imgs/logo_open_fiber_magenta@2x.png 2x"
				class="d-block mx-auto"
			/>
		</div>
		<form [formGroup]="signUpForm" class="row d-flex justify-content-center align-items-center">
			<div class="col-6">
				<mat-form-field appearance="outline" class="w-100">
					<input matInput formControlName="name" placeholder="Name" name="Name" required />
				</mat-form-field>
				<mat-form-field appearance="outline" class="w-100" required>
					<input matInput formControlName="surname" placeholder="Surname" name="Surname" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="w-100" required>
					<input matInput formControlName="email" type="email" placeholder="Email" name="Email" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="w-100">
					<input
						type="text"
						placeholder="Company"
						matInput
						formControlName="company"
						[matAutocomplete]="company"
					/>
					<mat-autocomplete #company="matAutocomplete" (optionSelected)="selectCompany($event)">
						<mat-option
							*ngFor="let option of filteredOptions | async"
							[value]="option.Name"
							(click)="selectCompany(option)"
							(keyup.enter)="selectCompany(option)"
						>
							{{ option.Name }}
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
				<mat-form-field appearance="outline" class="w-100">
					<input matInput formControlName="country" type="text" placeholder="Country" name="Country" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="w-100">
					<mat-select disableRipple floatLabel="never" placeholder="User type" formControlName="type">
						<mat-option *ngFor="let u of userTypeOptions" value="{{ u.value }}">{{ u.label }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</form>
		<div class="w-100 d-flex justify-content-center">
			<div class="flex-column align-items-center">
				<button
					mat-stroked-button
					[disabled]="disabled"
					class="btn pt-2 pb-2 rounded-0 mt-3 d-block"
					(click)="onSubmit()"
				>
					<mat-spinner *ngIf="waitLogin"></mat-spinner>
					<span *ngIf="!waitLogin">{{ "SIGNUP.SIGNUP" | translate }}</span>
				</button>
			</div>
		</div>
	</div>
</div>
